import API from '../../config/axiosConfig';

const API_URL = '/api/department-documents';

/**
 * One page of a department's documents plus every folder and the department's
 * document count. `params`: department, and one of folder / q (server search) /
 * all (every folder), with page and limit. See DepartmentDocumentsService.getLibrary.
 */
export const getLibrary = async (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  const response = await API.get(`${API_URL}?${query}`);
  return response.data;
};

export const getFolders = async (departmentId) => {
  const response = await API.get(`${API_URL}/folders?department=${encodeURIComponent(departmentId)}`);
  return response.data;
};

export const getDocument = async (id) => {
  const response = await API.get(`${API_URL}/${id}`, { handlingErrorLocally: true });
  return response.data;
};

// The file's bytes as a Blob. Streamed through the server (not a SAS URL), so
// every read is permission-checked and audited.
export const getDocumentFile = async (id) => {
  const response = await API.get(`${API_URL}/${id}/file`, { responseType: 'blob', handlingErrorLocally: true });
  return response.data;
};

// handlingErrorLocally: the upload dialog shows the failure next to its button.
// documentDate (YYYY-MM-DD) and author apply to every file; the server defaults
// them to today and the uploader.
export const uploadDocuments = async ({ department, folder, files, documentDate, author }) => {
  const formData = new FormData();
  formData.append('department', department);
  if (folder) formData.append('folder', folder);
  if (documentDate) formData.append('documentDate', documentDate);
  if (author) formData.append('author', author);
  files.forEach(file => {
    formData.append('files', file);
    formData.append('displayNames[]', file.displayName || '');
  });
  const response = await API.post(API_URL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    handlingErrorLocally: true
  });
  return response.data;
};

// Omitted fields stay as they are; '' clears documentDate (YYYY-MM-DD) or author.
export const updateDocument = async (id, { name, folder, documentDate, author }) => {
  const response = await API.put(`${API_URL}/${id}`, { name, folder, documentDate, author }, { handlingErrorLocally: true });
  return response.data;
};

export const deleteDocument = async (id) => {
  const response = await API.delete(`${API_URL}/${id}`, { handlingErrorLocally: true });
  return response.data;
};

export const createFolder = async ({ department, name, description, parent }) => {
  const response = await API.post(`${API_URL}/folders`, { department, name, description, parent }, { handlingErrorLocally: true });
  return response.data;
};

// Rename, re-describe and/or move (parent: null = the root). Omitted fields stay as they are.
export const updateFolder = async (id, { name, description, parent }) => {
  const response = await API.put(`${API_URL}/folders/${id}`, { name, description, parent }, { handlingErrorLocally: true });
  return response.data;
};

export const deleteFolder = async (id) => {
  const response = await API.delete(`${API_URL}/folders/${id}`, { handlingErrorLocally: true });
  return response.data;
};
